module.exports = __webpack_public_path__ + "img/iron.ee46d844.png";